export const CLOSE_MODAL = 'CLOSE_MODAL';
export const CLOSED_MODAL = 'CLOSED_MODAL';

export const SHOW_MODAL = 'SHOW_MODAL';
export const SHOWED_MODAL = 'SHOWED_MODAL';
